import React from 'react';
import ClientSlider from 'components/LandingPageCarousels/ClientSlider';
import Styles from './styles.js';
const AboutUsSlider = ({ bg, heading }) => {
  const clientsData = [
    {
      id: 1,
      image: 'pivot.png',
      name: 'client-1',
    },
    {
      id: 2,
      image: 'rental.png',
      name: 'client2',
    },
    {
      id: 3,
      image: 'globe.png',
      name: 'client-3',
    },
    {
      id: 4,
      image: 'nationalposts.png',
      name: 'client-4',
    },
    {
      id: 5,
      image: 'toronto.png',
      name: 'client-5',
    },
    {
      id: 6,
      image: 'rental.png',
      name: 'client-6',
    },
  ];

  const clientsDataBlack = [
    {
      id: 1,
      image: 'rental1.png',
      name: 'client-1',
    },
    {
      id: 2,
      image: 'torronto1.png',
      name: 'client2',
    },
    {
      id: 3,
      image: 'globe1.png',
      name: 'client-3',
    },
    {
      id: 4,
      image: 'rental1.png',
      name: 'client-1',
    },
    {
      id: 5,
      image: 'torronto1.png',
      name: 'client2',
    },
    {
      id: 6,
      image: 'globe1.png',
      name: 'client-3',
    },
  ];

  return (
    <div>
      {bg == 'black' ? (
        <div className="  " style={{ backgroundColor: '#171717' }}>
          <h1
            className="fs-36 pt-4 responsiveSz mt-2 mt-md-0 lh-45 fw-400 text-center"
            style={{ fontFamily: 'Josefin Sans', color: '#FBBE06' }}>
            {heading}
          </h1>
          <ClientSlider classN="clients-brand-carousel" clientsData={clientsDataBlack} icons={false} />
        </div>
      ) : (
        <div className="   ">
          <h1
            className="fs-36 responsiveSz mt-2 mt-md-0 lh-45 fw-400 text-center"
            style={{ fontFamily: 'Josefin Sans', color: '#ba8c00' }}>
            {heading}
          </h1>
          <ClientSlider classN="clients-brand-carousel" clientsData={clientsData} icons={true} />
        </div>
      )}
      <Styles/>
    </div>
  );
};

export default AboutUsSlider;
